import React from "react";
import Autosuggest from "react-autosuggest";
import "./styles.css";
import Spinner from "../../../components/Spinner";
import styled from "styled-components";

import axios from "axios";
import { BASE_URL } from "../../../constants";
import debounce from "lodash/debounce"; // Cherry-pick function for smaller webpack bundle.
import Icon from "../Icon";

// Styled components
const AutoCompleteWrap = styled.div`
  position: relative;
  height: 40px;
  /*Aligns spacing of input fields in mobile mode (to match Material UI spacing i.e. Date and Passenger fields)*/
  margin-bottom: 30px;
`;
const SpinnerWrap = styled.div`
  display: ${props => (props.displaySpinner ? "block" : "none")};
  position: absolute;
  bottom: 5px;
  right: 0;
  /* Aligns the spinner bottom on same level as text bottom. */
  top: 28px;
`;

const getPlace = suggestion => {
  const { city, country, state_code } = suggestion;

  // state_code seems to be for US states e.g. IL, TX etc.
  return `${city}, ${state_code ? state_code : country} - All Airports`;
};

// Displayed in drop down and input field e.g. O'Hare Intl Airport - ORD
const getAirportText = suggestion => {
  const { airport, iata } = suggestion;

  return `${airport} - ${iata}`;
};

// When suggestion is clicked, Autosuggest needs to populate the input
// based on the clicked suggestion. Teach Autosuggest how to calculate the
// input value for every given suggestion.
// const getSuggestionValue = suggestion => suggestion.place_name;
const getSuggestionValue = suggestion => ""; // <== This fn seems useless. How does it differ from renderSuggestion?

// Use your imagination to render suggestions.
const renderSuggestion = suggestion => {
  const dropDownStr =
    suggestion.type === "airport"
      ? getAirportText(suggestion)
      : getPlace(suggestion);
  return (
    <React.Fragment>
      <div>
        <Icon iconClass={"icofont-airplane"} />
      </div>
      <div>{dropDownStr}</div>
    </React.Fragment>
  );
};

class AutoCompleteField extends React.Component {
  constructor() {
    super();

    // Autosuggest is a controlled component.
    // This means that you need to provide an input value
    // and an onChange handler that updates this value (see below).
    // Suggestions also need to be provided to the Autosuggest,
    // and they are initially empty because the Autosuggest is closed.
    this.state = {
      value: "",
      focused: false,
      userIsTypingInField: false,
      dataSource: [],
      fetchingAutoCompleteLocations: false,
      fetchError: false
    };
  }

  // Api (remove eventually)
  // Debounce call to autocomplete results, for performance boost (so calls aren't made per input typed!)
  fetchAutoCompleteLocations = debounce(searchTerm => {
    if (searchTerm.length > 2) {
      var url = `${BASE_URL}/flights/autocomplete`;
      var self = this;

      self.setState({ fetchingAutoCompleteLocations: true }); // Displays spinner in auto complete field

      axios
        .post(url, { searchTerm })
        .then(response => {
          const data = response.data;
          self.setState({ dataSource: data });
          self.setState({ fetchingAutoCompleteLocations: false }); // removes spinner in auto complete field
        })
        .catch(err => {
          self.setState({ fetchingAutoCompleteLocations: false }); // removes spinner in auto complete field
          self.setState({ fetchError: true }); // removes spinner in auto complete field
          // console.log("err from auto complete", err);
        });
    }
  }, 300);

  updateInputValueInUi = value => {
    this.setState({
      value
    });
  };

  onSuggestionSelected = (event, { suggestion, method }) => {
    const { onChange: reduxFormOnChange } = this.props;
    // const { type, cityid_ppn, iata, city } = suggestion;
    const { type, cityid_ppn, iata } = suggestion;

    if (type === "airport") {
      reduxFormOnChange({
        locationId: iata,
        locationIdType: "iata",
        ...suggestion // Verbose, but details needed in /location-suggestions (in locationIdType !== manually_entered)
      }); // Store the value, in redux-form. This is used to make call to search for flights, and /location-suggestions
      this.updateInputValueInUi(getAirportText(suggestion));
    } else {
      // type === "city"
      reduxFormOnChange({
        // city,
        locationId: cityid_ppn,
        locationIdType: "cityid_ppn",
        ...suggestion // Verbose, but details needed in /location-suggestions (in locationIdType !== manually_entered)
      }); // Store the value, in redux-form. This is used to make call to search for flights, and /location-suggestions
      this.updateInputValueInUi(getPlace(suggestion));
    }
  };

  onChange = (event, { newValue, method }) => {
    const {
      onChange: reduxFormOnChange
      // fetchAutoCompleteLocations
    } = this.props;
    const fetchAutoCompleteLocations = this.fetchAutoCompleteLocations;

    // Fetch autocomplete airports/locations using user input
    // When something from dropdown is clicked, or when arrow keys are
    // used in selection of drowdown items, Autosuggest calls this onChange function,
    // triggering autocomplete api call.
    // This check prevents wasteful api fetches e.g. when method is various
    // options other than 'type' (it could be 'down' i.e. arrow down, 'up' etc.)

    // If the change occuring is from a user typing on keypad
    if (method === "type") {
      fetchAutoCompleteLocations(newValue); // Make api call with search term to get autocomplete suggestions
      reduxFormOnChange({
        locationId: newValue,
        locationIdType: "manually_entered"
      }); // alert redux-form of changes to Autosuggest
      this.updateInputValueInUi(newValue);
    }
  };

  // onKeyDown = e => {
  //   // var key = e.keyCode;
  //   // if (!(key === 8) && !(key === 46)) { // Backspace or delete pressed
  //   // console.log('keyDown', key)
  //   this.setState({ userIsTypingInField: true }); // To display spinner, giving the illusion of work
  //   // }
  // };
  // onKeyUp = e => {
  //   // var key = e.keyCode;
  //   // if (!key === 8 || !key === 46) {
  //   this.setState({ userIsTypingInField: false }); // remove displayed spinner
  //   // }
  // };
  onClick = e => {
    e.target.select(); /* Selects all input text onFocus*/
  };
  onFocus = e => {
    // e.target.select(); /* Selects all input text onFocus*/
    this.setState({ focused: true });
  };
  onBlur = e => {
    this.setState({ focused: false });
    // this.setState({ userIsTypingInField: false }); // remove displayed spinner
  };
  // When we interact with the field, Autosuggest will call this function, which
  // the current field value
  // ONLY IMPLEMENTING THIS TO PREVENT
  // "Uncaught TypeError: onSuggestionsFetchRequested is not a function" in console.
  onSuggestionsFetchRequested = () => {};
  onSuggestionsClearRequested = () => {};

  // // Autosuggest will call this function every time you need to clear suggestions.
  // onSuggestionsClearRequested = () => {
  //   this.setState({
  //     suggestions: []
  //   });
  // };

  render() {
    // const { value, suggestions } = this.state;
    const { value } = this.state;
    const {
      // fetchingAutoCompleteLocations,
      placeholderText,
      error,
      touched
      // onKeyDown,
      // dataSource
    } = this.props;
    const fetchingAutoCompleteLocations = this.state
      .fetchingAutoCompleteLocations;
    const isReduxFormError = error && touched;
    const dataSource = this.state.dataSource;

    // Autosuggest will pass through all these props to the input.
    const inputProps = {
      onFocus: this.onFocus,
      onBlur: this.onBlur,
      onClick: this.onClick,
      placeholder: placeholderText,
      value,
      onChange: this.onChange,
      autoFocus: this.props.autoFocus,
      name: this.props.name
    };

    // Finally, render it!
    return (
      <AutoCompleteWrap>
        <Autosuggest
          suggestions={dataSource ? dataSource : []}
          onSuggestionSelected={this.onSuggestionSelected}
          onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
          onSuggestionsClearRequested={this.onSuggestionsClearRequested}
          getSuggestionValue={getSuggestionValue}
          renderSuggestion={renderSuggestion}
          inputProps={inputProps}
        />
        <hr
          className={`react-autosuggest__input-bottom ${isReduxFormError &&
            "react-autosuggest__input-bottom--error"}`}
        />
        {isReduxFormError && (
          <span class="react-autosuggest__error-msg">{error}</span>
        )}
        <SpinnerWrap
          displaySpinner={fetchingAutoCompleteLocations && this.state.focused}
        >
          <Spinner />
        </SpinnerWrap>
      </AutoCompleteWrap>
    );
  }
}

export default AutoCompleteField;



// WEBPACK FOOTER //
// ./src/scenes/LandingPage/AutoCompleteField/index.js